import { Link } from "react-router-dom";
import { Phone, Mail } from "lucide-react";
import { Logo } from "./Logo";
import { SERVICES } from "../data/services";
import { CITIES } from "../data/cities";
import { CONTACT } from "../data/site";

export const Footer = () => (
    <footer className="bg-[#07080B] border-t border-white/10 pb-24" data-testid="site-footer">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
            <div className="col-span-2 md:col-span-1">
                <Link to="/" className="flex items-center gap-3" data-testid="footer-logo-link">
                    <Logo size={40} />
                    <span className="leading-none">
                        <span className="block font-display font-extrabold uppercase tracking-wider text-lg text-white">Xtreme Protection</span>
                        <span className="block font-mono-xp text-[10px] tracking-[0.25em] text-[#E53E3E] uppercase mt-0.5">Scotland Security Services</span>
                    </span>
                </Link>
                <p className="text-gray-400 text-sm leading-relaxed mt-5">
                    SIA-licensed security guard company protecting businesses across 22+ Scottish towns and cities — engineered deterrence with verified proof on every shift.
                </p>
                <div className="mt-5 space-y-2">
                    <a href={CONTACT.phoneHref} data-testid="footer-phone-link" className="flex items-center gap-2 text-sm text-gray-300 hover:text-[#E53E3E] transition-colors">
                        <Phone size={14} className="text-[#E53E3E]" /> {CONTACT.phone}
                    </a>
                    <a href={CONTACT.emailHref} data-testid="footer-email-link" className="flex items-center gap-2 text-sm text-gray-300 hover:text-[#E53E3E] transition-colors">
                        <Mail size={14} className="text-[#E53E3E]" /> {CONTACT.email}
                    </a>
                    <Link to="/blog" data-testid="footer-blog-link" className="flex items-center gap-2 text-sm text-gray-300 hover:text-[#E53E3E] transition-colors">
                        <span className="text-[#E53E3E] font-mono-xp text-xs">//</span> Security Intel &amp; Guides
                    </Link>
                </div>
            </div>
            <div>
                <h3 className="font-display uppercase tracking-wider text-white text-lg mb-4">Security Services</h3>
                <ul className="space-y-2">
                    {SERVICES.slice(0, 9).map((s) => (
                        <li key={s.slug}>
                            <Link to={`/services/${s.slug}`} data-testid={`footer-service-${s.slug}`} className="text-sm text-gray-400 hover:text-[#E53E3E] transition-colors">
                                {s.name} Scotland
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
            <div>
                <h3 className="font-display uppercase tracking-wider text-white text-lg mb-4">More Services</h3>
                <ul className="space-y-2">
                    {SERVICES.slice(9).map((s) => (
                        <li key={s.slug}>
                            <Link to={`/services/${s.slug}`} data-testid={`footer-service-${s.slug}`} className="text-sm text-gray-400 hover:text-[#E53E3E] transition-colors">
                                {s.name} Scotland
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
            <div>
                <h3 className="font-display uppercase tracking-wider text-white text-lg mb-4">Scotland Locations</h3>
                <ul className="space-y-2 columns-2 md:columns-1 gap-4">
                    <li className="break-inside-avoid">
                        <Link to="/contact" data-testid="footer-contact-link" className="text-sm text-[#E53E3E] hover:text-white transition-colors">
                            Contact Us
                        </Link>
                    </li>
                    <li className="break-inside-avoid">
                        <Link to="/regions/highlands-islands" data-testid="footer-region-highlands-islands" className="text-sm text-[#E53E3E] hover:text-white transition-colors">
                            Highlands &amp; Islands
                        </Link>
                    </li>
                    <li className="break-inside-avoid">
                        <Link to="/regions/central-belt" data-testid="footer-region-central-belt" className="text-sm text-[#E53E3E] hover:text-white transition-colors">
                            Central Belt
                        </Link>
                    </li>
                    <li className="break-inside-avoid">
                        <Link to="/regions/north-east" data-testid="footer-region-north-east" className="text-sm text-[#E53E3E] hover:text-white transition-colors">
                            North East &amp; Tayside
                        </Link>
                    </li>
                    <li className="break-inside-avoid">
                        <Link to="/regions/south-scotland" data-testid="footer-region-south-scotland" className="text-sm text-[#E53E3E] hover:text-white transition-colors">
                            South Scotland
                        </Link>
                    </li>
                    {CITIES.map((c) => (
                        <li key={c.slug} className="break-inside-avoid">
                            <Link to={`/locations/${c.slug}`} data-testid={`footer-city-${c.slug}`} className="text-sm text-gray-400 hover:text-[#E53E3E] transition-colors">
                                Security {c.name}
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3">
            <p className="font-mono-xp text-[11px] text-gray-500 uppercase tracking-widest">© {new Date().getFullYear()} Xtreme Protection — Scotland Security Services</p>
            <p className="font-mono-xp text-[11px] text-gray-500 uppercase tracking-widest">SIA Licensed // BS 7858 Vetted // 24/7 Command</p>
        </div>
    </footer>
);
